export var AppConfigContextEnum;
(function (AppConfigContextEnum) {
    AppConfigContextEnum["App"] = "APP";
    AppConfigContextEnum["BoxOffice"] = "BOX_OFFICE";
    AppConfigContextEnum["Checkout"] = "CHECKOUT";
    AppConfigContextEnum["PublicApi"] = "PUBLIC_API";
    AppConfigContextEnum["Ticketbuyer"] = "TICKETBUYER";
})(AppConfigContextEnum || (AppConfigContextEnum = {}));
export var AttachmentStatusEnum;
(function (AttachmentStatusEnum) {
    AttachmentStatusEnum["Pending"] = "PENDING";
    AttachmentStatusEnum["Ready"] = "READY";
    AttachmentStatusEnum["Uploading"] = "UPLOADING";
})(AttachmentStatusEnum || (AttachmentStatusEnum = {}));
export var BoxOfficeProcessorEnum;
(function (BoxOfficeProcessorEnum) {
    BoxOfficeProcessorEnum["External"] = "external";
    BoxOfficeProcessorEnum["Stripe"] = "stripe";
})(BoxOfficeProcessorEnum || (BoxOfficeProcessorEnum = {}));
export var CustomExpenseDeductedTypeEnum;
(function (CustomExpenseDeductedTypeEnum) {
    CustomExpenseDeductedTypeEnum["Gross"] = "GROSS";
    CustomExpenseDeductedTypeEnum["Net"] = "NET";
})(CustomExpenseDeductedTypeEnum || (CustomExpenseDeductedTypeEnum = {}));
export var CustomExpenseDueEnum;
(function (CustomExpenseDueEnum) {
    CustomExpenseDueEnum["ToArtist"] = "TO_ARTIST";
    CustomExpenseDueEnum["ToVenue"] = "TO_VENUE";
})(CustomExpenseDueEnum || (CustomExpenseDueEnum = {}));
export var DealEnum;
(function (DealEnum) {
    /** Artist Guarantee */
    DealEnum["ArtistGuarantee"] = "artist_guarantee";
    /** Artist Guarantee plus. GBOR after Expenses */
    DealEnum["ArtistGuaranteePlusGborAfterExpenses"] = "artist_guarantee_plus_gbor_after_expenses";
    /** Artist Guarantee vs GBOR */
    DealEnum["ArtistGuaranteeVsGbor"] = "artist_guarantee_vs_gbor";
    /** Artist Guarantee vs GBOR after Expenses */
    DealEnum["ArtistGuaranteeVsGborAfterExpenses"] = "artist_guarantee_vs_gbor_after_expenses";
    /** Flat fee to artist */
    DealEnum["FlatFee"] = "flat_fee";
    /** GBOR */
    DealEnum["Gbor"] = "gbor";
    /** GBOR after expenses */
    DealEnum["GborAfterExpenses"] = "gbor_after_expenses";
    /** Bar Guarantee due to Venue */
    DealEnum["GuaranteeToVenue"] = "guarantee_to_venue";
    /** None */
    DealEnum["None"] = "none";
    /** % of F&B sales if F&B exceeds amount after amount */
    DealEnum["PercentAfterHit"] = "percent_after_hit";
    /** % of F&B sales if F&B exceeds amount */
    DealEnum["PercentWithHit"] = "percent_with_hit";
    /** Rental fee to Venue */
    DealEnum["Rental"] = "rental";
    /** % of F&B sales */
    DealEnum["SalesPercentage"] = "sales_percentage";
})(DealEnum || (DealEnum = {}));
export var EventStateEnum;
(function (EventStateEnum) {
    EventStateEnum["Canceled"] = "CANCELED";
    EventStateEnum["Confirmed"] = "CONFIRMED";
    EventStateEnum["Deleted"] = "DELETED";
    EventStateEnum["Hold"] = "HOLD";
})(EventStateEnum || (EventStateEnum = {}));
export var EventsFilterEnum;
(function (EventsFilterEnum) {
    /** Show past events, most recent first */
    EventsFilterEnum["Past"] = "PAST";
    /** Show upcoming events, soonest first */
    EventsFilterEnum["Upcoming"] = "UPCOMING";
})(EventsFilterEnum || (EventsFilterEnum = {}));
export var FeeStructureEnum;
(function (FeeStructureEnum) {
    FeeStructureEnum["AtCost"] = "at_cost";
    FeeStructureEnum["Default"] = "default";
    FeeStructureEnum["Discount"] = "discount";
    FeeStructureEnum["Standard"] = "standard";
    FeeStructureEnum["Waived"] = "waived";
})(FeeStructureEnum || (FeeStructureEnum = {}));
export var ListTypeEnum;
(function (ListTypeEnum) {
    /** Guest list */
    ListTypeEnum["GuestList"] = "guest_list";
    /** Paid list */
    ListTypeEnum["PaidList"] = "paid_list";
})(ListTypeEnum || (ListTypeEnum = {}));
export var PaymentTypeEnum;
(function (PaymentTypeEnum) {
    PaymentTypeEnum["Cash"] = "CASH";
    PaymentTypeEnum["Check"] = "CHECK";
    PaymentTypeEnum["CreditCard"] = "CREDIT_CARD";
    PaymentTypeEnum["None"] = "NONE";
    PaymentTypeEnum["WireTransfer"] = "WIRE_TRANSFER";
})(PaymentTypeEnum || (PaymentTypeEnum = {}));
export var RefundActionEnum;
(function (RefundActionEnum) {
    RefundActionEnum["Credit"] = "CREDIT";
    RefundActionEnum["Donate"] = "DONATE";
    RefundActionEnum["Refund"] = "REFUND";
})(RefundActionEnum || (RefundActionEnum = {}));
export var RefundStatusEnum;
(function (RefundStatusEnum) {
    RefundStatusEnum["Credited"] = "CREDITED";
    RefundStatusEnum["Donated"] = "DONATED";
    RefundStatusEnum["None"] = "NONE";
    RefundStatusEnum["Refunded"] = "REFUNDED";
    RefundStatusEnum["RefundChoose"] = "REFUND_CHOOSE";
})(RefundStatusEnum || (RefundStatusEnum = {}));
export var SettlementTaxWithholdingTypeEnum;
(function (SettlementTaxWithholdingTypeEnum) {
    SettlementTaxWithholdingTypeEnum["Fixed"] = "FIXED";
    SettlementTaxWithholdingTypeEnum["Percentage"] = "PERCENTAGE";
})(SettlementTaxWithholdingTypeEnum || (SettlementTaxWithholdingTypeEnum = {}));
export var SettlementTypeEnum;
(function (SettlementTypeEnum) {
    /** Settlement based on manual ticket sales entry */
    SettlementTypeEnum["ManualGbor"] = "MANUAL_GBOR";
    /** Settlement based on tickets sales at selected events in corresponding event group */
    SettlementTypeEnum["TicketSalesEvents"] = "TICKET_SALES_EVENTS";
})(SettlementTypeEnum || (SettlementTypeEnum = {}));
export var ShoppingCartItemTypeEnum;
(function (ShoppingCartItemTypeEnum) {
    ShoppingCartItemTypeEnum["Discount"] = "DISCOUNT";
    ShoppingCartItemTypeEnum["Donation"] = "DONATION";
    ShoppingCartItemTypeEnum["Presale"] = "PRESALE";
    ShoppingCartItemTypeEnum["SeatTicket"] = "SEAT_TICKET";
    ShoppingCartItemTypeEnum["Ticket"] = "TICKET";
})(ShoppingCartItemTypeEnum || (ShoppingCartItemTypeEnum = {}));
export var TrackingProviderEnum;
(function (TrackingProviderEnum) {
    /** Facebook pixel */
    TrackingProviderEnum["Facebook"] = "facebook";
    /** Google Analytics */
    TrackingProviderEnum["Ga"] = "ga";
})(TrackingProviderEnum || (TrackingProviderEnum = {}));
export var VariableExpenseEnum;
(function (VariableExpenseEnum) {
    /** % of GBOR */
    VariableExpenseEnum["GborPercentage"] = "gbor_percentage";
    /** Per Attendee */
    VariableExpenseEnum["PerAttendee"] = "per_attendee";
    /** Per ticket */
    VariableExpenseEnum["PerTicket"] = "per_ticket";
})(VariableExpenseEnum || (VariableExpenseEnum = {}));
const result = {
    "possibleTypes": {}
};
export default result;
//# sourceMappingURL=graphql.js.map